import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import useInfinitScroll from 'srcReact/helpers/hooks/useInfinitScroll'
import { discoverActions } from 'srcReact/DiscoverPage'
import NotFound from 'srcReact/components/common2/NotFound'
import { default as CTAButton } from 'srcReact/components/common2/NotFound'
import { redirectToPage } from 'srcReact/helpers/history'
import Spinner from 'srcReact/components/common2/Spinner'
import { checkNested } from 'srcReact/helpers/validator'
import { isHDPlusScreen, urlSearchParams } from 'srcReact/helpers/utils'
import Masonry from 'srcReact/components/common2/Masonry'
import Group from '../Group'
import LightProfileProto from 'srcReact/components/common2/LightProfileModal/LightProfilPrototype'
import { lightProfileActions } from 'srcReact/components/common2/LightProfileModal/actions'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { canCreateGroup } from 'srcReact/helpers/userHelper'

const MyGroups = ({ showAccordion, groupScope, groupOrderChanged }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [pagination, setPagination] = useState({
    nextOffset: 0,
    isPagination: false
  })
  const {
    common: { isMobile, isNative, userLocation },
    discover: { all, myGroupsLoading },
    organization: { current_organization }
  } = useSelector((state) => state)

  useEffect(() => {
    if (groupOrderChanged) {
      // nativeapp
      if (isNative) {
        dispatch(
          discoverActions.getDiscoverGroupList(
            urlSearchParams('id_workplace').toString(),
            groupScope,
            urlSearchParams('lat'),
            urlSearchParams('lon'),
            pagination.nextOffset
          )
        )
        return
      }

      if (checkNested(current_organization, 'info', 'my_access', 'role_as_workplace_member')) {
        const workplaceIds = current_organization.info.my_access.role_as_workplace_member.workplace_list
        if (workplaceIds && workplaceIds.length >= 1 && userLocation) {
          dispatch(
            discoverActions.getDiscoverGroupList(
              workplaceIds.toString(),
              groupScope,
              userLocation.latitude,
              userLocation.longitude,
              pagination.nextOffset
            )
          )
        }
      }
    }
  }, [groupOrderChanged])
  useEffect(() => {
    // nativeapp
    if (isNative && pagination.isPagination) {
      dispatch(
        discoverActions.getDiscoverGroupListPagination(
          urlSearchParams('id_workplace').toString(),
          groupScope,
          urlSearchParams('lat'),
          urlSearchParams('lon'),
          pagination.nextOffset
        )
      )
      return
    }

    if (checkNested(current_organization, 'info', 'my_access', 'role_as_workplace_member')) {
      const workplaceIds = current_organization.info.my_access.role_as_workplace_member.workplace_list
      if (workplaceIds && workplaceIds.length >= 1 && pagination.isPagination && userLocation) {
        dispatch(
          discoverActions.getDiscoverGroupListPagination(
            workplaceIds.toString(),
            groupScope,
            userLocation.latitude,
            userLocation.longitude,
            pagination.nextOffset
          )
        )
      }
    }
  }, [pagination])

  const infiniteScrollRef = useInfinitScroll(
    myGroupsLoading,
    groupScope === 'allgroups'
      ? all.stats.total_all_groups - all.group_list.length
      : all.stats.total_groups - all.group_list.length,
    all.group_list.length,
    setPagination,
    [myGroupsLoading, all.stats]
  )

  const showUserModal = (e, user) => {
    if (e) {
      e.stopPropagation()
    }

    const lp = new LightProfileProto()
    lp.userId = user.organizer_id
    dispatch(lightProfileActions.openLightProfileModal(lp))
  }

  return (
    <div className={styles.groupsWrapper}>
      {all.myGroupsLoading && !all.myGroupsLoaded ? (
        <Spinner />
      ) : showAccordion && all.group_list && all.group_list.length >= 1 ? (
        <div className={styles.cardWrapper}>
          <Masonry
            columns={
              isMobile || all.group_list.length === 1 ? 1 : isHDPlusScreen() && all.group_list.length > 2 ? 3 : 2
            }
            childrenClassName={styles.children}>
            {all.group_list.map((g, i, arr) => (
              <React.Fragment key={i}>
                {current_organization &&
                  canCreateGroup(current_organization) &&
                  i === appConstantSettings.CTA_BUTTON_DISPLAY - 1 && (
                    <CTAButton
                      title={t('global.ctaGroupTitle')}
                      button={t('nav.create_group')}
                      handleClick={() => redirectToPage(`/0/create-group`, isNative)}
                    />
                  )}
                <Group
                  g={g}
                  i={i}
                  groupScope={groupScope}
                  handleClick={() => redirectToPage(`/0/home/group/${g.group_id}`, isNative, true)}
                  infiniteScrollRef={infiniteScrollRef}
                  showUserModal={showUserModal}
                  isSuspended={
                    checkNested(all, 'moderation_info', 'groups', 'suspended_groups') &&
                    all.moderation_info.groups.suspended_groups.some((x) => x === g.group_id)
                  }
                />
                {current_organization &&
                  canCreateGroup(current_organization) &&
                  i < appConstantSettings.CTA_BUTTON_DISPLAY - 1 &&
                  i === arr.length - 1 && (
                    <CTAButton
                      title={t('global.ctaGroupTitle')}
                      button={t('nav.create_group')}
                      handleClick={() => redirectToPage(`/0/create-group`, isNative)}
                    />
                  )}
              </React.Fragment>
            ))}
          </Masonry>
          {myGroupsLoading && <Spinner />}
        </div>
      ) : (
        showAccordion &&
        all.group_list &&
        all.group_list.length === 0 &&
        all.myGroupsLoaded && <NotFound title={t('discover.mygroups.notFound.title')} className={styles.notFound} />
      )}
    </div>
  )
}

export default MyGroups
